module.exports = __webpack_public_path__ + "static/media/power-bump-black-fr.9f72fbaa.png";